const ASSETS = 'https://biblicalgeography3dguide.lovable.app/assets'

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/iDAExCUby7DmShWDscot1M/ChatGPT_Image_13_ago_2026,_04_34_26_p.m..png'
export const caesareaImage = `${ASSETS}/caesarea-philippi-DRXOKRBy.webp`
export const lockedPageImage =
  'https://cdn.magicpatterns.com/uploads/dQt1SWSWv8FJ276HWYeqFZ/img_3_biblia_carrusel.png'

export type ImageItem = {
  src: string
  caption: string
}

export const heroStats = [
  { value: '300+', label: 'Imágenes 3D' },
  { value: '300+', label: 'Páginas' },
  { value: '100%', label: 'Precisión histórica' },
]

export const previewPages: ImageItem[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/bXP3fQ5Wa9otTgyUusLBMD/img1_biblia_carrusel.png',
    caption: 'Ruta de las Siete Iglesias del Apocalipsis',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kVCkMVwZimvb3JedXuyLUj/img_2_carrusel_biblia.png',
    caption: 'El santuario central en tiempos de Jesús',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dQt1SWSWv8FJ276HWYeqFZ/img_3_biblia_carrusel.png',
    caption: 'Betania y la tumba de Lázaro',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aMeBgiiwVWQ7LXtiC6uG2X/img_4_biblia_carrusel.png',
    caption: 'La iglesia primitiva y los viajes de Pablo',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sfUa2uQ3cHWyds5PrRtu9q/img_5_biblia_carrusel.png',
    caption: 'Cómo era la forma del Arca de Noé',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5dhSpNyj9umqo9SEXacbZb/img_6_biblia_carrusel.png',
    caption: 'El viaje de Pablo a Roma',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1RvTWVQ9K4qcz9JyEJZJDm/img_7_biblia_carrusel.png',
    caption: 'Atlas resumen del Nuevo Testamento',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/djFyyNmCDV4ZLx49pbMM9s/img_8_biblia_carrusel.png',
    caption: 'El altar en el monte Moriah',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nXC36Utsw7nVUVGPi6DdJM/img_9_biblia_carrusel.png',
    caption: 'Samaria, Siquén y el Pozo de Jacob',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6ocYLgozpCYAXUkMZvfQy9/img_10_biblia_carrusel.png',
    caption: 'Relieve, clima y rutas del mundo bíblico',
  },
]

export const chapters: ImageItem[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/eAMpg1pS85uratyrFHT3ry/portada_biblia_1.png',
    caption:
      'El escenario donde comienza la historia bíblica, con las primeras tierras, pueblos y rutas mencionadas en Génesis.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5XfWApg1nwoLhn7pc7MwyG/portada_biblia_2.png',
    caption:
      'Los caminos de la liberación de Israel, desde Egipto hasta el desierto, en un entorno real y desafiante.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oRPkeEuHCeCaKbN9h3krHY/portada_biblia_3.png',
    caption: 'Las ciudades y territorios donde Israel se estableció en la Tierra Prometida.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5MtrbCjuEygnHkW1RovM1r/portada_biblia_4.png',
    caption: 'Un período marcado por conflictos, líderes regionales y transición política.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tQcZrWHJkAJkco6STaA473/portada_biblia_5.png',
    caption: 'El apogeo de Israel, con Jerusalén como centro religioso y político.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tMZA3Ku8Myj1c9Aiiz3vPp/portada_biblia_6.png',
    caption: 'El período del cautiverio y el regreso a la tierra natal.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vNwbYafr84DkL27E5aM37Y/portada_7_biblia.png',
    caption: 'Los lugares donde Jesús nació, vivió y enseñó.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2rdbDKNVCd9iRTZBp1Bfv5/portada_8_biblia.png',
    caption: 'Las rutas y ciudades por donde se expandió el cristianismo.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9jUiXaeH57CncEtddt2dET/portada_9_biblia.png',
    caption: 'El contexto de las iglesias y las visiones finales del Nuevo Testamento.',
  },
]

export const visualTypes: ImageItem[] = [
  { src: `${ASSETS}/visual-1-en-GEYJvYqz.webp`, caption: 'Mapa 3D — Escalera de Tiro, Aczib y Abdón' },
  { src: `${ASSETS}/visual-2-en-HI5dC1-w.webp`, caption: 'Viajes misioneros del apóstol Pablo' },
  { src: `${ASSETS}/visual-3-en-DgZgzl3_.webp`, caption: 'Reconstrucción 3D de una antigua ciudad bíblica' },
  { src: `${ASSETS}/visual-4-en-DuJXVonH.webp`, caption: 'Reconstrucción 3D de Jerusalén con la Fortaleza Antonia' },
  { src: `${ASSETS}/visual-5-en-CIwM-_jl.webp`, caption: 'El Tabernáculo en el desierto' },
  { src: `${ASSETS}/visual-6-en-DzCFbR5S.webp`, caption: 'Torre de Babel — Reconstrucción 3D' },
]

export const includedFeatures = [
  'Cobertura completa: los 66 libros de la Biblia',
  'Mapas, cartografía y rutas detalladas',
  'Reconstrucciones 3D de templos y ciudades',
  'Más de 300 imágenes 3D en alta resolución',
]

export const audiences = [
  { emoji: '📖', label: 'Grupos de estudio bíblico' },
  { emoji: '✝️', label: 'Maestros de escuela dominical' },
  { emoji: '🏛️', label: 'Pastores y ministros' },
  { emoji: '🎓', label: 'Estudiantes de teología' },
]

export const testimonials = [
  {
    name: 'Gabriel M.',
    location: 'Córdoba',
    quote:
      '¡Increíble! Nunca imaginé que la Biblia pudiera ser tan visual. Los mapas 3D me ayudaron muchísimo en mi grupo de estudio bíblico.',
  },
  {
    name: 'Valeria S.',
    location: 'Mendoza',
    quote:
      'Preparo la escuela dominical cada semana y ahora los chicos ven exactamente dónde ocurrió cada historia. Cambió por completo mis clases.',
  },
  {
    name: 'Rubén A.',
    location: 'Santa Fe',
    quote:
      'Llevo años predicando y esta guía me dio contexto que jamás había visto. Vale cada peso por la calidad de las reconstrucciones.',
  },
]

export const offerItems = [
  {
    emoji: '📘',
    label: 'Guía Geografía Bíblica 3D — de Génesis a Apocalipsis',
    price: '$34.900',
    badge: '$16.990',
  },
  { emoji: '🎁', label: '+8 Bonos exclusivos incluidos', price: '$44.900' },
  { emoji: '🔄', label: 'Actualizaciones semanales con nuevos mapas y contenido', price: '$9.900' },
  { emoji: '♾️', label: 'Acceso de por vida — tuyo para siempre', price: '$17.900' },
  { emoji: '💬', label: 'Soporte al cliente dedicado', price: '$9.300' },
]

export const offerPricing = {
  totalValue: '$116.900',
  regularPrice: '$116.900',
  finalPrice: '$16.990',
  savings: '$99.910',
  viewers: 12,
}

export const faqs = [
  {
    question: '¿Cómo recibo la guía después de comprar?',
    answer:
      'El acceso es inmediato. En cuanto se confirma el pago recibes un correo con el enlace de descarga en PDF. No hay envío físico ni tiempos de espera.',
  },
  {
    question: '¿Funciona en celular, tablet y computadora?',
    answer:
      'Sí. El PDF está optimizado para leerse en cualquier dispositivo y también puedes imprimirlo si prefieres estudiar en papel.',
  },
  {
    question: '¿Sirve con mi traducción de la Biblia?',
    answer:
      'Sí. La guía es compatible con Reina-Valera, NVI, LBLA, DHH y todas las traducciones principales en español.',
  },
  {
    question: '¿Es apropiada para cualquier denominación?',
    answer:
      'Totalmente. El contenido es geográfico e histórico, basado 100% en el texto bíblico, sin sesgo denominacional.',
  },
  {
    question: '¿Y si no me gusta?',
    answer:
      'Tienes 7 días de garantía incondicional. Escribes un correo y te devolvemos el 100% de tu dinero, sin preguntas.',
  },
]
